/**
 * The printed boxes of the Coast Guard IAP cover sheet, numbered as the sheet numbers them.
 *
 * Kept beside the card the way `ics201BoxLabels` is, so the on-screen boxes and the exported PDF can be read against
 * each other without either restating the other's wording.
 */

export const IAP_COVER_BOX_LABELS = {
  incidentName: '1. Incident Name:',
  incidentLocation: '2. Incident Location:',
  operationalPeriod: '3. Operational Period (Date/Time):',
  approvedByIc: '4. Approved by Incident Commander(s):',
  formsAndDocuments: '5. Forms and Documents:',
  preparedBy: '6. Prepared by:',
} as const;

export const IAP_COVER_OPERATIONAL_PERIOD_HINT =
  'Click this box to set the scheduled start and end of the next operational period for this incident workspace. The cover prints the same window the rest of the plan does.';

export const IAP_COVER_APPROVAL_HINT =
  'Every Incident Commander on the roster signs their own row, so a unified command approves the plan jointly. Approval opens once the IAP has been generated.';

export const IAP_COVER_ATTACHMENTS_HINT =
  'These boxes decide which forms are merged into the exported IAP as well as what the cover advertises. Attached files are appended to the end of the plan; the free-text rows only name something travelling alongside it.';
